import * as React from 'react'
import Button from '../Button'

export function buttonsFrom(actions, overrides = {}) {
  if (Array.isArray(actions)) {
    return actions.map((action, index) => buttonFrom(action, overrides, index))
  } else {
    const action = actions
    return buttonFrom(action, overrides)
  }
}

export function buttonFrom({ content, onAction, ...action }, overrides, key) {
  return (
    <Button key={key} onClick={onAction} {...action} {...overrides}>
      {content}
    </Button>
  )
}



// WEBPACK FOOTER //
// ./src/components/Button/utils.js